import { useState, useEffect } from 'react';
import { t, getLanguage, onLanguageChange } from '../lib/i18n';

export function useTranslation() {
  const [, setTick] = useState(0);

  useEffect(() => {
    return onLanguageChange(() => setTick(v => v + 1));
  }, []);

  return { t, lang: getLanguage() };
}
